export const DATE_FORMAT_SLASH = "YYYY/MM/DD"
export const DATE_FORMAT_READABLE = "YYYY MMM DD"

export const DATETIME_FORMAT = "YYYY/MM/DD HH:mm:ss"
export const DATETIME_FORMAT_READABLE = "YYYY MMM DD, HH:mm:ss"
